import { Button } from "@/common/components-2/button";
import { MigrationLink } from "@/common/components-2/migration-link";
import { isNil } from "@/common/helpers/lang";
import { DescriptionComponent, HeadingComponent, StepTitleComponent } from "./how-it-works-section";
import type { HowItWorksWithTabsSectionProps } from "./how-it-works-section.types";
import { TabsSection } from "./tabs-section";

export function HowItWorksWithTabsSection({
  title,
  description,
  tabs,
  buttonLabel,
  buttonUrl,
}: HowItWorksWithTabsSectionProps) {
  const isButton = !isNil(buttonLabel) && !isNil(buttonUrl);

  return (
    <div className="flex flex-col lg:flex-row lg:gap-16 lg:pt-20">
      <div className="order-2 pt-12 lg:order-1 lg:flex lg:flex-1 lg:flex-col lg:justify-center lg:p-0">
        <StepTitleComponent index={-1} />
        <HeadingComponent heading={title} />
        <DescriptionComponent description={description} />
        {isButton ? (
          <Button variant="primary" className="mt-14 w-full lg:w-max" size="lg" asChild>
            <MigrationLink href={buttonUrl}>{buttonLabel}</MigrationLink>
          </Button>
        ) : null}
      </div>
      <div className="order-1 lg:order-2 lg:flex-1">
        <TabsSection items={tabs} />
      </div>
    </div>
  );
}
